<template>
  <footer class="footer-container">
    <div class="footer">
      <div class="logo">
        <router-link class="text-decoration-none" :to="{ name: 'home' }">
          <img
            loading="lazy"
            title="CrowdHrs"
            src="/img/crowdhrs.svg"
            alt="CrowdHrs"
          />
          <p>{{ $t('recruitment') }}</p>
        </router-link>
      </div>
      <div class="footer-menu">
        <div class="footer-sub">{{ $t('about') }}</div>
        <nav>
          <router-link :to="{ name: 'about' }">{{ $t('company') }}</router-link>
          <router-link :to="{ name: 'contactUs' }">{{
            $t('contact')
          }}</router-link>
        </nav>
      </div>
      <div class="footer-menu">
        <div class="footer-sub">{{ $t('resources') }}</div>
        <nav>
          <router-link :to="{ name: 'howItWorks' }">{{
            $t('howitworks')
          }}</router-link>
          <router-link :to="{ name: 'faq' }">FAQ</router-link>
        </nav>
      </div>
      <div class="footer-menu">
        <div class="footer-sub">{{ $t('legal') }}</div>
        <nav>
          <router-link :to="{ name: 'privacyPolicy' }">{{ $t('privacy') }}</router-link>
          <router-link :to="{ name: 'termsOfService' }">{{ $t('termsofservice') }}</router-link>
        </nav>
      </div>
      <div class="footer-menu">
        <div class="footer-sub">Contact Us</div>
        <nav>
          <a :href="`tel:${phone}`" class="contact-link">
            <i class="pi pi-phone"></i> {{ phone }}
          </a>
          <a :href="`mailto:${contact_email}`" class="contact-link">
            <i class="pi pi-envelope"></i> {{ contact_email }}
          </a>
        </nav>
      </div>
      <div class="copyright">
        Copyright @CrowdHRs {{ new Date().getFullYear() }} All Rights Reserved
      </div>
    </div>
  </footer>
</template>
<style lang="scss" scoped>
.copyright {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  padding-block: 24px;
  width: 100%;
  margin-top: 30px;
  border-top: 1px solid #eee;
  order: 999;
  
  @media (max-width: 1024px) {
    margin-top: 20px;
  }
}

.footer-container {
  height: 100%;
  border-top: 1px solid #eeeeee;
  background-color: #fff;
  box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.03);
}

.footer {
  max-width: 1440px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 20px;
  position: relative;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  
  .logo {
    margin-top: 48px;
    margin-bottom: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    @media (max-width: 1024px) {
      margin-bottom: 0;
    }

   

    p {
      font-weight: 500;
      font-size: 16px;
      line-height: 28px;
      color: #444444;
      text-align: center;
      text-decoration: none;
      margin-top: 8px;
    }
  }

  .footer-menu {
    margin-block: 48px;
    transition: transform 0.3s ease;
    
    @media (max-width: 1024px) {
      margin-block: 15px;
      width: 100%;
      max-width: 280px;
    }
    
    nav {
      display: flex;
      flex-direction: column;
      gap: 14px;
      align-items: center;
      
      a {
        text-align: center;
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;
        color: #666;
        text-decoration: none;
        transition: all 0.2s ease;
        position: relative;
        padding: 3px 0;
        
        &:hover {
          color: #333;
          transform: translateY(-2px);
        }
        
        &:after {
          content: '';
          position: absolute;
          width: 0;
          height: 2px;
          bottom: 0;
          left: 50%;
          background-color: #333;
          transition: all 0.3s ease;
        }
        
        &:hover:after {
          width: 100%;
          left: 0;
        }
      }
      
      .contact-link {
        display: flex;
        align-items: center;
        gap: 8px;
        
        i {
          color: #555;
        }
      }
    }
    
    .footer-sub {
      text-align: center;
      margin-bottom: 22px;
      font-weight: 600;
      font-size: 17px;
      line-height: 24px;
      color: #333;
      position: relative;
      padding-bottom: 10px;
      
      &:after {
        content: '';
        position: absolute;
        width: 30px;
        height: 2px;
        background-color: #555;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>

<script>
import { ref } from 'vue'
import { post } from '@/api/Services'

export default {
  emits: [],
  data() {
    return {
      contact_email: ref(''),
      phone: ref(''),
    }
  },
  props: {},
  methods: {
    async cms() {
      const parameters = [
        {
          parameter_name: 'piv_page_path',
          parameter_value: '/contact-us',
        },
        {
          parameter_name: 'piv_tag_group',
          parameter_value: 'general',
        },
      ]

      await post('/Commons/Executer', {
        sqlId: 76,
        parameters: JSON.stringify(parameters),
      })
        .then((data) => {
          data.map((item) => {
            switch (item.tag) {
              case 'email':
                this.contact_email = item.html_content
                break
              case 'phone':
                this.phone = item.html_content
                break
            }
          })
        })
        .catch((err) => console.log(err))
    },
  },
  mounted() {
    this.cms()
  },
}
</script>
